import {
    LOAD_OPENING_HOURS_SUCCESS,
    CLEAR_OPENING_HOURS
} from "../../../../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOAD_OPENING_HOURS_SUCCESS:
            return action.payload;
        case CLEAR_OPENING_HOURS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/settings/restaurant/OpenigHoursReducer.js